import { useMemo, useRef } from 'react';
import { useModal } from '../../../providers/ModalProvider';
import Modal from '../Modal';
import { modals } from '../../../providers/modals';
import { QRCodeCanvas } from 'qrcode.react';
import { keys } from '../../../utilities/translator/translation_keys';
import { useTranslation } from 'react-i18next';

export default function QRModal() {
  const { closeModal, modalState } = useModal();
  const { show, key, pathname, workspaceId, templateId, url } =
    modalState.qrModal;
  const { t } = useTranslation();

  const link = useMemo(() => {
    if (url) return url;

    const origin =
      (process.env.REACT_APP_DOMAIN || '').replace(`//$/, ''`) ||
      window.location.origin;

    const sanitizedPath = String(pathname || '').replace(/^\//, '');
    if (!sanitizedPath || !workspaceId || !key) return '';

    const params = new URLSearchParams({
      workspaceId: String(workspaceId),
      accessKey: String(key),
      templateId: String(templateId),
    });

    return `${origin}/${sanitizedPath}?${params.toString()}`;
  }, [key, pathname, workspaceId, templateId, url]);

  const canvasWrapRef = useRef(null);

  const downloadPNG = () => {
    const canvas = canvasWrapRef.current?.querySelector('canvas');
    if (!canvas) return;

    const pngUrl = canvas.toDataURL('image/png');
    const a = document.createElement('a');
    a.href = pngUrl;
    a.download = 'qrcode.png';
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  return (
    <Modal
      hideCancel
      submitText={t(keys.action.DOWNLOAD)}
      submitButtonIcon="download"
      open={show}
      onClose={() => closeModal({ modalName: modals.qr })}
      onSubmit={downloadPNG}
      title={t(keys.openLink.QR_CODE)}
    >
      <div
        ref={canvasWrapRef}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginBottom: '1rem',
        }}
      >
        {link ? (
          <QRCodeCanvas
            value={link}
            size={256}
            level="H"
            bgColor="#ffffff"
            fgColor="#000000"
          />
        ) : null}
      </div>
    </Modal>
  );
}
